/**
 * StatusBadIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const StatusBadIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2m3.54 12.12a1 1 0 0 1-.71 1.71 1 1 0 0 1-.71-.29L12 13.41l-2.12 2.13a1 1 0 0 1-.71.29 1 1 0 0 1-.71-1.71L10.59 12 8.46 9.88a1.004 1.004 0 0 1 1.42-1.42L12 10.59l2.12-2.13a1.004 1.004 0 0 1 1.42 1.42L13.41 12z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const StatusBadIcon = makeIcon('StatusBadIcon', StatusBadIconSvg)
